import { ResourceType } from '../shared/resource-type';

export const PAGINATED_LIST = new ResourceType('paginated-list');
